/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { MouseEvent } from "react";
import useNavigate, { NavigateFunc } from "../../../../Basis/Utils/useNavigate";
import WindowUtil from "../../../../Basis/Utils/WindowUtil";
import ViewModel from "../../../../Basis/ViewModels/ViewModel";
import UIConstants from "../../../../UIConstants";
import { useAppHelpContext } from "../AppHelpContext";
import IAppHelpContext from "../AppHelpContext/IAppHelpContext";
import AppHelpState, { createInitialState } from "./AppHelpState";

export default class AppHelpModel extends ViewModel<AppHelpState> {
    private readonly _appHelpContext: IAppHelpContext;
    private readonly _navigate: NavigateFunc;

    public constructor() {
        super({
            initialState: createInitialState(),
        });

        this._appHelpContext = useAppHelpContext();
        this._navigate = useNavigate();
    }

    public get isMenuOpen(): boolean {
        return Boolean(this.state.anchorEl);
    }

    public readonly openMenu = (e: MouseEvent<HTMLElement>) => {
        const currentTarget = e.currentTarget;
        this.setState(next => {
            next.anchorEl = currentTarget;
        });
    };

    public readonly closeMenu = () => {
        this.setState(next => {
            next.anchorEl = undefined;
        });
    };

    public get isKontaktformularDialogOpen(): boolean {
        return this._appHelpContext.isKontaktformularDialogOpen;
    }

    public get isAboutDialogOpen(): boolean {
        return this.state.isAboutDialogOpen;
    }

    public readonly onKontaktformularGesendet = () => {
        this._appHelpContext.setIsKontaktformularDialogOpen(false);
    }

    public readonly onKontaktformularAbgebrochen = () => {
        this._appHelpContext.setIsKontaktformularDialogOpen(false);
    }

    public readonly onAboutOk = () => {
        this.setState(next => {
            next.isAboutDialogOpen = false;
        });
    }

    public readonly fragenUndAntworten = () => {
        WindowUtil.oeffneInTab(UIConstants.faqUrl);
        this.closeMenu();
    };

    public readonly oeffneKontaktformular = () => {
        this._appHelpContext.setIsKontaktformularDialogOpen(true);
        this.closeMenu();
    };

    public readonly neuigkeiten = () => {
        WindowUtil.oeffneInTab(UIConstants.blogUrl);
        this.closeMenu();
    };

    public readonly ueber = () => {
        this.setState(next => {
            next.isAboutDialogOpen = true;
        });
        this.closeMenu();
    };

    public readonly oeffneFeedback = () => {
        this._navigate("verbesserungsvorschlaege", { replace: false, enableChangeTracking: true });
        this.closeMenu();
    };

    public readonly oeffneRoadmap = () => {
        this._navigate("roadmap", { replace: false, enableChangeTracking: true });
        this.closeMenu();
    };
}
